import {useTranslation} from "react-i18next";
import {Card, Tabs} from "antd";
import {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import CardTitle from "../../core/components/CardTitle";
import AppConfig from "../../core/service/AppConfig";
import AppLogViewer from "../../app/log/app-log-viewer/AppLogViewer";
import OnlineUsersPanel from "../../app/log/online-users/OnlineUsersPanel";
import RouteStatsPanel from "../../app/log/route-stats/RouteStatsPanel";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";

const TABS = ['logs', 'online', 'endpoints'];

export default function AppLogViewerPage()
{
    const {t} = useTranslation();
    const history = useHistory();
    const location = useLocation();

    // Aktif sekme URL'de tutulur: link paylaşılabilsin, detaydan geri dönüşte sekme korunsun.
    // ?route=... ile gelindiyse (Endpointler sekmesinden tıklama) log sekmesi açılır.
    const params = new URLSearchParams(location.search);
    const [tab, setTab] = useState(TABS.includes(params.get('tab')) ? params.get('tab') : 'logs');

    useEffect(() => {
        document.title = `${t('App Logs')} | ${AppConfig.getRisTitle()}`
    }, []);

    const onTabChange = (key) => {
        setTab(key);
        history.replace(key === 'logs' ? location.pathname : `${location.pathname}?tab=${key}`);
    };

    // Sider yok (sidebarComponent verilmiyor → 0 genişliğe çöker), tam genişlikte içerik.
    return (
        <LayoutWithSider fullWidth={true}>
            <Card title={<CardTitle title={t('App Logs')} />}>
                <Tabs
                    activeKey={tab}
                    onChange={onTabChange}
                    // Kapalı sekme unmount edilir: Çevrimiçi panelinin 15 sn'lik tazeleme timer'ı arkada dönmesin.
                    destroyInactiveTabPane
                    items={[
                        {
                            key: 'logs',
                            label: t('App Logs'),
                            children: <AppLogViewer />
                        },
                        {
                            key: 'online',
                            label: t('Online'),
                            children: <OnlineUsersPanel />
                        },
                        {
                            key: 'endpoints',
                            label: t('Endpoints'),
                            children: <RouteStatsPanel />
                        }
                    ]}
                />
            </Card>
        </LayoutWithSider>
    )
}
